import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import { useSupabase } from '../contexts/SupabaseContext';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedAdminRoute - Protects admin routes by requiring authentication
 * 
 * Note: This component only checks authentication. Actual admin authorization
 * is enforced by the backend API endpoints. If a non-admin user accesses this route,
 * they will be able to see the UI but all API calls will be rejected by the backend.
 */
export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isAuthenticated, isLoading } = useSupabase();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box minH="100vh" bg="#120F1B" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="xl" color="#C6D959">Loading...</Text>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated - allow access
  // Backend will enforce admin authorization on all API calls
  return <>{children}</>;
}

